/** O documento é o scroller da aplicação desde que o `#app-main` deixou de rolar. */
export function scrollAppToTop() {
  window.scrollTo({ top: 0, left: 0 });
}
